(function ($) {
	$.fn.frShareButton = function () {
        const toggleOpenDropdown = ($self) => {
            $self.toggleClass('is--opened', !$self.hasClass('is--opened'));
        }

		return this.each((i, el) => {
			const $self = $(el);
            const $btn = $self.find('.fr-share-btn-el');
            const $linkIcon = $self.find('.social-sharing-links .share-btn.link');

            $btn.on('click', (e) => {
                toggleOpenDropdown($self);
            });

            $(document).on('click', (ev) => {
                if(!$(ev.target).closest('.fr-share-button').length && $self.hasClass('is--opened')){
                    $self.removeClass('is--opened');
                }
            });

            $linkIcon.on('click', (e) => {
                e.preventDefault();

                if(window.navigator){
                    window.navigator.clipboard.writeText($linkIcon.attr('href'));

                    $linkIcon.find('.link-btn-copied').addClass('is--animated');

                    setTimeout(() => {
                        $linkIcon.find('.link-btn-copied').removeClass('is--animated')
                    }, 1000);
                }
            })
		});
	}

	$.initialize('.fr-share-button', function(){
		$(this).frShareButton();
	});
})($);